import moment from 'moment';

/* eslint-disable */
export const ProductType = 'RPDPRC';

export enum ProductPermissions {
  PRICING = 'PRICING',
}

export const EXCEL_COLUMN_HEADER = {
  ZONE: 'Zone',
  TYPE: 'Type',
  DEPARTMENT: 'Department',
  SUB_DEPARTMENT: 'Subdepartment',
  BRACKET: 'Bracket',
  RMS_ITEM_NUMBER: 'RMS Number',
  WEEKLY_RATE_NEW: 'Weekly Rate New',
  WEEKLY_RATE_USED: 'Weekly Rate Used',
  ADDON_WEEKLY_RATE: 'Add-On Weekly Rate',
  TERM: 'Term',
  CASH_PRICE_FACTOR: 'Cash Price Factor',
  FORCED_CASH_PRICE: 'Forced Cash Price',
  MANUAL_PO_TURNS: 'Manual PO Turns',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  VALIDATION_STATUS: 'Validation Status',
  VALIDATION_COMMENTS: 'Validation Comments',
  UPLOAD_STATUS: 'Upload Status',
  UPLOAD_COMMENTS: 'Upload Comments',
  SAC_DAYS: 'SAC Days',
  SAC_DAYS_PRINTED: 'SAC Days Printed',
  CLEARANCE: 'Clearance',
  EPO_PERCENT: 'EPO Percentage',
};

export const EXCEL_COLUMN_VALUES = {
  ZONE_INDEX: 0,
  TYPE_INDEX: 1,
  DEPARTMENT_INDEX: 2,
  SUB_DEPARTMENT_INDEX: 3,
  BRACKET_INDEX: 4,
  RMS_ITEM_NUMBER_INDEX: 5,
  WEEKLY_RATE_NEW_INDEX: 6,
  WEEKLY_RATE_USED_INDEX: 7,
  ADDON_WEEKLY_RATE_INDEX: 8,
  TERM_INDEX: 9,
  CASH_PRICE_FACTOR_INDEX: 10,
  FORCED_CASH_PRICE_INDEX: 11,
  MANUALPO_TURNS_INDEX: 12,
  SAC_DAYS_INDEX: 13,
  SAC_DAYS_PRINTED_INDEX: 14,
  EPO_PERCENT_INDEX: 15,
  CLEARANCE_INDEX: 16,
  START_DATE_INDEX: 17,
  END_DATE_INDEX: 18,
  VALIDATION_STATUS_INDEX: 19,
  VALIDATION_COMMENTS_INDEX: 20,
  UPLOAD_STATUS_INDEX: 21,
  UPLOAD_COMMENTS_INDEX: 22,
};
export const VERIFY_IN_PROG = 'Verification In-progress';
export const REMOVE_PRICING = 'Remove Pricing';

export const excelColumnOrder = [
  'zoneNumber',
  'departmentName',
  'subDepartmentName',
  'bracketName',
  'rmsItemNumber',
  'rmsItemDescription',
  'pricingType',
  'weeklyRateNew',
  'weeklyRateUsed',
  'weeklyRateAddOn',
  'term',
  'cashPriceFactor',
  'forcedCashPrice',
  'manualPoTurns',
  'sacDays',
  'sacDaysPrinted',
  'epoPercent',
  'brandName',
  'modelNumber',
  'purchaseCost',
  'eaFlag',
  'clearance',
  'cashPriceNew',
  'cashPriceTurn',
  'totalCostNew',
  'totalRtoTurn',
  'cashPriceUsed',
  'totalCostUsed',
  'startDate',
  'endDate',
];

export const headerMapping: { [key: string]: string } = {
  zoneNumber: 'Zone Number',
  departmentName: 'Department Name',
  subDepartmentName: 'Sub Department Name',
  bracketName: 'Bracket Name',
  rmsItemNumber: 'RMS Item Number',
  rmsItemDescription: 'RMS Item Description',
  pricingType: 'Pricing Type',
  weeklyRateNew: 'Weekly Rate New',
  weeklyRateUsed: 'Weekly Rate Used',
  weeklyRateAddOn: 'Add-On Rate',
  term: 'Term',
  cashPriceFactor: 'Cash Price Factor',
  forcedCashPrice: 'Forced Cash Price',
  manualPoTurns: 'Manual PO-Turns',
  sacDays: 'SAC Days',
  sacDaysPrinted: 'SAC Days Printed',
  epoPercent: 'EPO Percentage',
  brandName: 'Brand',
  modelNumber: 'Model#',
  purchaseCost: 'Purchase Cost',
  eaFlag: 'EA Flag',
  clearance: 'Clearance',
  cashPriceNew: 'Cash Price (NEW)',
  cashPriceTurn: 'Cash Price Turns (NEW)',
  totalCostNew: 'Total Cost (NEW)',
  totalRtoTurn: 'TRTO Turns (NEW)',
  cashPriceUsed: 'Cash Price (USED)',
  totalCostUsed: 'Total Cost (USED)',
  startDate: 'Start Date',
  endDate: 'End Date',
};

export const columnWidths = [
  { wch: 15 }, // Zone Number
  { wch: 20 }, // Department Name
  { wch: 20 }, // Sub Department Name
  { wch: 10 }, // Bracket Name
  { wch: 15 }, // RMS Item Number
  { wch: 35 }, // RMS Item Description
  { wch: 15 }, // Pricing Type
  { wch: 15 }, // Weekly Rate New
  { wch: 15 }, // Weekly Rate Used
  { wch: 15 }, // Add-On Rate
  { wch: 10 }, // Term
  { wch: 15 }, // Cash Price Factor
  { wch: 15 }, // Forced Cash Price
  { wch: 15 }, // Manual PO-Turns
  { wch: 15 }, // Purchase Cost
  { wch: 15 }, // Brand
  { wch: 15 }, // Model#
  { wch: 10 }, // ea Flag
  { wch: 15 }, // Cash Price (NEW)
  { wch: 20 }, // Cash Price Turns (NEW)
  { wch: 15 }, // Total Cost (NEW)
  { wch: 15 }, // TRTO Turns (NEW)
  { wch: 15 }, // Cash Price (USED)
  { wch: 15 }, // Total Cost (USED)
  { wch: 15 }, // Start Date
  { wch: 15 }, // End Date
];

export const VERIFYPRC = 'VERIFYPRC';

export const EXCEL_HEADER_SC_INDEX = {
  ZONE_IND: 0,
  DEPARTMENT_IND: 1,
  SUB_DEPARTMENT_IND: 2,
  BRACKET_IND: 3,
  BRAND_IND: 4,
  RMS_IND: 5,
  RULE_TYPE_IND: 6,
  RULE_APP_ORDER_IND: 7,
  CRITERIA_TYPE_IND: 8,
  PRICE_PARAM_IND: 9,
  EFFECT_TYPE_IND: 10,
  START_RANGE_IND: 11,
  END_RANGE_IND: 12,
  CATEGORY_TYPE_IND: 13,
  CATEGORY_SUBTYPE_IND: 14,
  EQUATION_TYPE_IND: 15,
  EQUATION_PARAM_IND: 16,
  DISCOUNT_VALUE_IND: 17,
  START_DATE_IND: 18,
  END_DATE_IND: 19,
  VALIDATION_STATUS_IND: 20,
  VALIDATION_COMMENT_IND: 21,
  UPLOAD_STATUS_IND: 22,
  UPLAOD_COMMENTS_IND: 23,
};
export const CRITERIA_HEADERS = {
  ZONE_SC: 'Zone',
  DEPARTMENT_SC: 'Department',
  SUBDEPARTMENT_SC: 'Subdepartment',
  BRACKET_SC: 'Bracket',
  BRAND_SC: 'Brand',
  RMS_NUMBER_SC: 'RMS Number',
  RULE_TYPE: 'Rule Type',
  RULE_APPLICATION_ORDER: 'Rule Application Order',
  SECONDARY_CRITERIA_TYPE: 'Secondary Criteria Type',
  PRICE_PARAMETER: 'Price Parameter',
  CRITERIA_EFFECT_TYPE: 'Criteria Effect Type',
  START_RANGE: 'Start Range',
  END_RANGE: 'End Range',
  CATEGORY_TYPE: 'Category Type',
  CATEGORY_SUBTYPE: 'Category Subtype',
  EQUATION_TYPE: 'Equation Type',
  EQUATION_KEY: 'Equation Key',
  DISCOUNT_VALUE: 'Discount Value',
  START_DATE_SC: 'Start Date',
  END_DATE_SC: 'End Date',
  VALIDATION_STATUS_SC: 'Validation Status',
  VALIDATION_COMMENTS_SC: 'Validation Comments',
  UPLOAD_STATUS_SC: 'Upload Status',
  UPLOAD_COMMENTS_SC: 'Upload Comments',
};
export const SECONDARY_CRITERIA = 'Secondary Criteria';
export const SECONDARY_CRITERIA_EQUATION = 'Secondary Criteria Equation'
export const CRITERIA_EFFECTIVE_TYPE = ['NUMBER', 'PERCENTAGE'];

export const errorMessage = {
  equationAccessError: 'Access to this feature is currently restricted to this user'
}

export const EXCEL_HEADER_RMVPRC_INDEX = {
  ZONE_RMVPRC_IND: 0,
  TYPE_RMVPRC_IND: 1,
  DEPARTMENT_RMVPRC_IND: 2,
  SUB_DEPARTMENT_RMVPRC_IND: 3,
  BRACKET_RMVPRC_IND: 4,
  RMS_RMVPRC_IND: 5,
  FROM_RANGE_RMVPRC_IND: 6,
  TO_RANGE_RMVPRC_IND: 7,
  VALIDATION_STATUS_RMVPRC_IND: 8,
  VALIDATION_COMMENT_RMVPRC_IND: 9,
  UPLOAD_STATUS_RMVPRC_IND: 10,
  UPLOAD_COMMENTS_RMVPRC_IND: 11,
}

export const REMOVE_PRC_HEADERS = {
  ZONE_RMVPRC: 'Zone',
  TYPE_RMVPRC: 'Type',
  DEPARTMENT_RMVPRC: 'Department',
  SUB_DEPARTMENT_RMVPRC: 'Subdepartment',
  BRACKET_RMVPRC: 'Bracket',
  RMS_RMVPRC: 'RMS Number',
  FROM_RANGE_RMVPRC: 'From Range',
  TO_RANGE_RMVPRC: 'To Range',
  VALIDATION_STATUS_RMVPRC: 'Validation Status',
  VALIDATION_COMMENT_RMVPRC: 'Validation Comments',
  UPLOAD_STATUS_RMVPRC: 'Upload Status',
  UPLOAD_COMMENTS_RMVPRC: 'Upload Comments',
}

export const ALLOWED_RMV_PRC_TYPES = ['TEMPORARY']

export const EXCEL_HEADER_RMVPRC_ALLTYPES_INDEX = {
  ZONE_RMVPRC_AT_IND: 0,
  TYPE_RMVPRC_AT_IND: 1,
  DEPARTMENT_RMVPRC_AT_IND: 2,
  SUB_DEPARTMENT_RMVPRC_AT_IND: 3,
  BRACKET_RMVPRC_AT_IND: 4,
  RMS_RMVPRC_AT_IND: 5,
  ALL_PRICING_PARAMS_RMVPRC_AT_IND: 6,
  WEEKLY_RATE_TERM_RMVPRC_AT_IND: 7,
  ADDON_WEEKLY_RATE_RMVPRC_AT_IND: 8,
  CASH_PRICE_RMVPRC_AT_IND: 9,
  SAC_DAYS_RMVPRC_AT_IND: 10,
  EPO_PERCENTAGE_RMVPRC_AT_IND: 11,
  MANUAL_PO_TURNS_RMVPRC_AT_IND: 12,
  CLEARANCE_RMVPRC_AT_IND: 13,
  FROM_RANGE_RMVPRC_AT_IND: 14,
  TO_RANGE_RMVPRC_AT_IND: 15,
  VALIDATION_STATUS_RMVPRC_AT_IND: 16,
  VALIDATION_COMMENT_RMVPRC_AT_IND: 17,
  UPLOAD_STATUS_RMVPRC_AT_IND: 18,
  UPLOAD_COMMENTS_RMVPRC_AT_IND: 19,
};

export const REMOVE_PRC_ALLTYPES_HEADERS = {
  ZONE_RMVPRC_AT: 'Zone',
  TYPE_RMVPRC_AT: 'Type',
  DEPARTMENT_RMVPRC_AT: 'Department',
  SUB_DEPARTMENT_RMVPRC_AT: 'Subdepartment',
  BRACKET_RMVPRC_AT: 'Bracket',
  RMS_RMVPRC_AT: 'RMS Number',
  ALL_PRICING_PARAMS_RMVPRC_AT: 'All Pricing Parameters',
  WEEKLY_RATE_TERM_RMVPRC_AT: 'Weekly Rate and Term',
  ADDON_WEEKLY_RATE_RMVPRC_AT: 'Add-On Weekly Rate',
  CASH_PRICE_RMVPRC_AT: 'Cash Price',
  SAC_DAYS_RMVPRC_AT: 'SAC Days',
  EPO_PERCENTAGE_RMVPRC_AT: 'EPO Percentage',
  MANUAL_PO_TURNS_RMVPRC_AT: 'Manual PO Turns',
  CLEARANCE_RMVPRC_AT: 'Clearance',
  FROM_RANGE_RMVPRC_AT: 'From Range',
  TO_RANGE_RMVPRC_AT: 'To Range',
  VALIDATION_STATUS_RMVPRC_AT: 'Validation Status',
  VALIDATION_COMMENT_RMVPRC_AT: 'Validation Comments',
  UPLOAD_STATUS_RMVPRC_AT: 'Upload Status',
  UPLOAD_COMMENTS_RMVPRC_AT: 'Upload Comments',
};

export const ALLOWED_RMV_PRC_TYPES_ALL = ['TEMPORARY', 'PERMANENT', 'MANUAL'];

export const EXCEL_HEADER_RMVSC_INDEX = {
  ZONE_RMVSC_IND: 0,
  DEPARTMENT_RMVSC_IND: 1,
  SUB_DEPARTMENT_RMVSC_IND: 2,
  BRACKET_RMVSC_IND: 3,
  RMS_RMVSC_IND: 4,
  BRAND_RMVSC_IND: 5,
  RULE_TYPE_RMVSC_IND: 6,
  CRITERIA_TYPE_RMVSC_IND: 7,
  PRICE_PARAM_RMVSC_IND: 8,
  EFFECT_TYPE_RMVSC_IND: 9,
  RULE_APP_ORDER_RMVSC_IND: 10,
  CATEGORY_TYPE_RMVSC_IND: 11,
  CATEGORY_SUBTYPE_RMVSC_IND: 12,
  EQUATION_TYPE_RMVSC_IND: 13,
  START_DATE_RMVSC_IND: 14,
  END_DATE_RMVSC_IND: 15,
  VALIDATION_STATUS_RMVSC_IND: 16,
  VALIDATION_COMMENT_RMVSC_IND: 17,
  UPLOAD_STATUS_RMVSC_IND: 18,
  UPLOAD_COMMENTS_RMVSC_IND: 19,
}

export const REMOVE_SC_HEADERS = {
  ZONE_RMVSC: 'Zone',
  DEPARTMENT_RMVSC: 'Department',
  SUB_DEPARTMENT_RMVSC: 'Subdepartment',
  BRACKET_RMVSC: 'Bracket',
  RMS_RMVSC: 'RMS Number',
  BRAND_RMVSC: 'Brand',
  RULE_TYPE_RMVSC: 'Rule Type',
  CRITERIA_TYPE_RMVSC: 'Secondary Criteria Type',
  PRICE_PARAM_RMVSC: 'Price Parameter',
  EFFECT_TYPE_RMVSC: 'Criteria Effect Type',
  RULE_APP_ORDER_RMVSC: 'Rule Application Order',
  CATEGORY_TYPE_RMVSC: 'Category Type',
  CATEGORY_SUBTYPE_RMVSC: 'Category Subtype',
  EQUATION_TYPE_RMVSC: 'Equation Type',
  START_DATE_RMVSC: 'From Range',
  END_DATE_RMVSC: 'To Range',
  VALIDATION_STATUS_RMVSC: 'Validation Status',
  VALIDATION_COMMENT_RMVSC: 'Validation Comments',
  UPLOAD_STATUS_RMVSC: 'Upload Status',
  UPLOAD_COMMENTS_RMVSC: 'Upload Comments',
}

export const CostBasedPricingHeading = [
  {
    heading: 'Zone', isSortable: false,
    sortDirection: "DESC",
    key: "zoneNumber",
    isSorted: false
  },
  {
    heading: 'Department', isSortable: false,
    sortDirection: "DESC",
    key: "department",
    isSorted: false
  },
  {
    heading: 'Sub-Department', isSortable: false,
    sortDirection: "DESC",
    key: "subdepartment",
    isSorted: false
  },
  {
    heading: 'Bracket', isSortable: false,
    sortDirection: "DESC",
    key: "bracket",
    isSorted: false
  },
  {
    heading: 'Min Rate %', isSortable: true,
    sortDirection: "DESC",
    key: "minRatePct",
    isSorted: true
  },
  {
    heading: 'Max Rate %', isSortable: true,
    sortDirection: "DESC",
    key: "maxRatePct",
    isSorted: true
  },
  {
    heading: 'Min Rate (NEW)', isSortable: true,
    sortDirection: "DESC",
    key: "minRateNew",
    isSorted: true
  },
  {
    heading: 'Max Rate (NEW)', isSortable: true,
    sortDirection: "DESC",
    key: "maxRateNew",
    isSorted: true
  },
  {
    heading: 'Min Rate (USED)', isSortable: true,
    sortDirection: "DESC",
    key: "minRateUsed",
    isSorted: true
  },
  {
    heading: 'Max Rate (USED)', isSortable: true,
    sortDirection: "DESC",
    key: "maxRateUsed",
    isSorted: true
  },
  {
    heading: 'Turns', isSortable: true,
    sortDirection: "DESC",
    key: "turn",
    isSorted: true
  },
  {
    heading: 'Term Max', isSortable: true,
    sortDirection: "DESC",
    key: "termMax",
    isSorted: true
  },
  {
    heading: 'Initial Amount (A)', isSortable: true,
    sortDirection: "DESC",
    key: "initialAmount",
    isSorted: true
  },
  {
    heading: 'Growth (r)', isSortable: true,
    sortDirection: "DESC",
    key: "growth",
    isSorted: true
  },
  {
    heading: 'Line Shift LR (m)', isSortable: true,
    sortDirection: "DESC",
    key: "lineShiftLR",
    isSorted: true
  },
  {
    heading: 'Line Shift UD (k)', isSortable: true,
    sortDirection: "DESC",
    key: "lineShiftUD",
    isSorted: true
  },
  {
    heading: 'Used Rate Adjustment (y)', isSortable: true,
    sortDirection: "DESC",
    key: "usedRateAdj",
    isSorted: true
  },
  {
    heading: 'Publish on Cost Change', isSortable: true,
    sortDirection: "DESC",
    key: "publishOnCostChangeFlag",
    isSorted: true
  },
  {
    heading: 'Start Date', isSortable: true,
    sortDirection: "DESC",
    key: "startDate",
    isSorted: true
  },
  {
    heading: 'End Date', isSortable: true,
    sortDirection: "DESC",
    key: "endDate",
    isSorted: true
  },
  {
    heading: 'Action', isSortable: true,
    sortDirection: "DESC",
    key: "action",
    isSorted: false
  }
]

export const sortArray = (
  columnId: string,
  index: number,
  datacolumn: any,
  dataValues: any,
  compareBy: 'number' | 'string' | 'date',
  setGridHeaders: any,
  setSearchContent: any
) => {
  // Determine sort direction
  const direction = datacolumn[index].sortDirection === 'DESC' ? -1 : 1;

  // Sort dataValues based on the compareBy type and direction
  const sortedData = dataValues.sort((a: any, b: any) => {
    let comparison = 0;

    // Compare based on the type
    if (compareBy === 'number') {
      comparison = Number(a[columnId]) - Number(b[columnId]);
    } else if (compareBy === 'string') {
      comparison = a[columnId]?.localeCompare(b[columnId]) || 0;  // Handles undefined/null
    } else if (compareBy === 'date') {
      const dateA = moment(a[columnId]);
      const dateB = moment(b[columnId]);
      comparison = dateA.isBefore(dateB) ? -1 : (dateA.isAfter(dateB) ? 1 : 0);
    }

    // Return the result of comparison multiplied by direction
    return comparison * direction;
  });

  // Toggle the sort direction for future calls
  const reorderColumns = [...datacolumn];
  reorderColumns[index].sortDirection = direction === 1 ? 'DESC' : 'ASC';

  setSearchContent([...sortedData]);
  setGridHeaders([...reorderColumns]);
};

export const ZoneBasedPricingHeading = [
  {
    heading: 'Zone', isSortable: true,
    sortDirection: "DESC",
    key: "zoneNumber",
    isSorted: true
  },
  {
    heading: 'Department', isSortable: false,
    sortDirection: "DESC",
    key: "department",
    isSorted: false
  },
  {
    heading: 'Sub-Department', isSortable: false,
    sortDirection: "DESC",
    key: "subdepartment",
    isSorted: false
  },
  {
    heading: 'Bracket', isSortable: false,
    sortDirection: "DESC",
    key: "bracket",
    isSorted: false
  },
  {
    heading: 'New and Used Rate Prem', isSortable: true,
    sortDirection: "DESC",
    key: "newAndUsedRatePrem",
    isSorted: true
  },
  {
    heading: 'Brand New Rate Prem', isSortable: true,
    sortDirection: "DESC",
    key: "brandNewRatePrem",
    isSorted: true
  },
  {
    heading: 'Total Turns', isSortable: true,
    sortDirection: "DESC",
    key: "turn",
    isSorted: true
  },
  {
    heading: 'Term Prem', isSortable: true,
    sortDirection: "DESC",
    key: "termPrem",
    isSorted: true
  },
  {
    heading: 'Recalculate Term', isSortable: true,
    sortDirection: "DESC",
    key: "reCalculateTerm",
    isSorted: true
  },
  {
    heading: 'Start Date', isSortable: true,
    sortDirection: "DESC",
    key: "startDate",
    isSorted: true
  },
  {
    heading: 'End Date', isSortable: true,
    sortDirection: "DESC",
    key: "endDate",
    isSorted: true
  },
  {
    heading: 'Action', isSortable: true,
    sortDirection: "DESC",
    key: "action",
    isSorted: false
  }
]

export const EXCEL_HEADER_CBPRC_INDEX = {
  ZONE_CBPRC_IND: 0,
  DEPARTMENT_CBPRC_IND: 1,
  SUB_DEPARTMENT_CBPRC_IND: 2,
  BRACKET_CBPRC_IND: 3,
  MIN_RATE_PCT_CBPRC_IND: 4,
  MAX_RATE_PCT_CBPRC_IND: 5,
  MIN_RATE_NEW_CBPRC_IND: 6,
  MAX_RATE_NEW_CBPRC_IND: 7,
  MIN_RATE_USED_CBPRC_IND: 8,
  MAX_RATE_USED_CBPRC_IND: 9,
  TURNS_CBPRC_IND: 10,
  TERMS_MAX_CBPRC_IND: 11,
  INITIAL_AMOUNT_CBPRC_IND: 12,
  GROWTH_CBPRC_IND: 13,
  LINE_SHIFT_LR_CBPRC_IND: 14,
  LINE_SHIFT_UD_CBPRC_IND: 15,
  USED_RATE_ADJUSTMENT_CBPRC_IND: 16,
  PUBLISH_ON_COST_CHANGE_CBPRC_IND: 17,
  START_DATE_CBPRC_IND: 18,
  END_DATE_CBPRC_IND: 19,
  VALIDATION_STATUS_CBPRC_IND: 20,
  VALIDATION_COMMENTS_CBPRC_IND: 21,
  UPLOAD_STATUS_CBPRC_IND: 22,
  UPLOAD_COMMENTS_CBPRC_IND: 23,
};

export const COST_BASED_PRC_HEADERS = {
  ZONE_CBPRC: 'Zone',
  DEPARTMENT_CBPRC: 'Department',
  SUB_DEPARTMENT_CBPRC: 'Subdepartment',
  BRACKET_CBPRC: 'Bracket',
  MIN_RATE_PCT_CBPRC: 'Min Rate %',
  MAX_RATE_PCT_CBPRC: 'Max Rate %',
  MIN_RATE_NEW_CBPRC: 'Min Rate New',
  MAX_RATE_NEW_CBPRC: 'Max Rate New',
  MIN_RATE_USED_CBPRC: 'Min Rate Used',
  MAX_RATE_USED_CBPRC: 'Max Rate Used',
  TURNS_CBPRC: 'Turns',
  TERMS_MAX_CBPRC: 'Terms Max',
  INITIAL_AMOUNT_CBPRC: 'Initial Amount (A)',
  GROWTH_CBPRC: 'Growth (r)',
  LINE_SHIFT_LR_CBPRC: 'Line Shift LR (m)',
  LINE_SHIFT_UD_CBPRC: 'Line Shift UD (k)',
  USED_RATE_ADJUSTMENT_CBPRC: 'Used Rate Adjustment (y)',
  PUBLISH_ON_COST_CHANGE_CBPRC: 'Publish on Cost Change',
  START_DATE_CBPRC: 'Start Date',
  END_DATE_CBPRC: 'End Date',
  VALIDATION_STATUS_CBPRC: 'Validation Status',
  VALIDATION_COMMENTS_CBPRC: 'Validation Comments',
  UPLOAD_STATUS_CBPRC: 'Upload Status',
  UPLOAD_COMMENTS_CBPRC: 'Upload Comments',
};

export const EXCEL_HEADER_ZBPRC_INDEX = {
  ZONE_ZBPRC_IND: 0,
  DEPARTMENT_ZBPRC_IND: 1,
  SUB_DEPARTMENT_ZBPRC_IND: 2,
  BRACKET_ZBPRC_IND: 3,
  NEW_USED_RATE_PREM_ZBPRC_IND: 4,
  BRAND_NEW_RATE_PREM_ZBPRC_IND: 5,
  TOTAL_TURNS_ZBPRC_IND: 6,
  TERM_PREM_ZBPRC_IND: 7,
  RECALCULATE_TERM_ZBPRC_IND: 8,
  START_DATE_ZBPRC_IND: 9,
  END_DATE_ZBPRC_IND: 10,
  VALIDATION_STATUS_ZBPRC_IND: 11,
  VALIDATION_COMMENTS_ZBPRC_IND: 12,
  UPLOAD_STATUS_ZBPRC_IND: 13,
  UPLOAD_COMMENTS_ZBPRC_IND: 14,
};

export const ZONE_BASED_PRC_HEADERS = {
  ZONE_ZBPRC: 'Zone',
  DEPARTMENT_ZBPRC: 'Department',
  SUB_DEPARTMENT_ZBPRC: 'Subdepartment',
  BRACKET_ZBPRC: 'Bracket',
  NEW_USED_RATE_PREM_ZBPRC: 'New and Used Rate Prem',
  BRAND_NEW_RATE_PREM_ZBPRC: 'Brand New Rate Prem',
  TOTAL_TURNS_ZBPRC: 'Total Turns',
  TERM_PREM_ZBPRC: 'Term Prem',
  RECALCULATE_TERM_ZBPRC: 'Recalculate Term',
  START_DATE_ZBPRC: 'Start Date',
  END_DATE_ZBPRC: 'End Date',
  VALIDATION_STATUS_ZBPRC: 'Validation Status',
  VALIDATION_COMMENTS_ZBPRC: 'Validation Comments',
  UPLOAD_STATUS_ZBPRC: 'Upload Status',
  UPLOAD_COMMENTS_ZBPRC: 'Upload Comments',
};

export const USER_GENERATED = ['Pricing', 'StoreZone', 'Autoterm', 'Package', 'Zone', 'Unassigned', 'Secondary Criteria', 'Auto Generated Price', 'Zone Based Pricing', 'Cost Based Pricing']

export const SYSTEM_GENERATED = ['Pricing Automation', 'OverallMissingPrice']
